import {
    getAdFormatAdTemplateDataRequest,
    getAdFormatsDataRequest,
    getAgeGroupDataRequest,
    getDateDataRequest,
    getEnvironmentDataRequest,
    getGenderDataRequest,
    getOSDataRequest,
    getOverallFunnelPerformanceDataRequest,
    getRegionDataRequest,
    getWeekdayDataRequest,
    getAdInteractionDataRequest
} from "@api/common";
import { FetchingState, FETCH_STATE } from "rd-redux-http";

export interface SingleChartState<TChart> {
    fetchState: FETCH_STATE;
    chartData: TChart;
}

export interface ChartsDataState {
    overallData: typeof getOverallFunnelPerformanceDataRequest.types.reduxState;
    dateData: typeof getDateDataRequest.types.reduxState;
    environmentData: typeof getEnvironmentDataRequest.types.reduxState;
    weekdayData: typeof getWeekdayDataRequest.types.reduxState;
    ageGroupData: typeof getAgeGroupDataRequest.types.reduxState;
    genderData: typeof getGenderDataRequest.types.reduxState;
    osData: typeof getOSDataRequest.types.reduxState;
    regionData: typeof getRegionDataRequest.types.reduxState;
    adFormatData: typeof getAdFormatsDataRequest.types.reduxState;
    adFormatAdTemplateData: typeof getAdFormatAdTemplateDataRequest.types.reduxState;
    adInteractionData: typeof getAdInteractionDataRequest.types.reduxState;
}

export const defaultChartsDataState: ChartsDataState = {
    overallData: { fetchState: FetchingState.INITIAL },
    dateData: { fetchState: FetchingState.INITIAL },
    environmentData: { fetchState: FetchingState.INITIAL },
    weekdayData: { fetchState: FetchingState.INITIAL },
    ageGroupData: { fetchState: FetchingState.INITIAL },
    genderData: { fetchState: FetchingState.INITIAL },
    osData: { fetchState: FetchingState.INITIAL },
    regionData: { fetchState: FetchingState.INITIAL },
    adFormatData: { fetchState: FetchingState.INITIAL },
    adFormatAdTemplateData: { fetchState: FetchingState.INITIAL },
    adInteractionData: { fetchState: FetchingState.INITIAL }
};
